import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OrderConfirmationMarkModule } from '../orderConfirmationMark';
import { OrderInfoModule } from '../orderInfo';
import { OrderConfirmationHeroHeaderComponent } from './order-confirmation-hero-header.shared.component';

@NgModule({
    declarations: [
        OrderConfirmationHeroHeaderComponent
    ],
    imports: [
        CommonModule,
        OrderConfirmationMarkModule,
        OrderInfoModule,
    ],
    exports: [
        OrderConfirmationHeroHeaderComponent
    ],
})
export class OrderConfirmationHeroHeaderModule { }
